// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=pro` then `environment.pro.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  // api: 'http://localhost:3000/'
  api: 'https://traffico-api-bcn.geographica.gs/',
  imageHost: '',
  city: 'bcn',
  title: 'Barcelona',
  citylogo: '/assets/logos/barcelona.svg',
  citylogoMobile: '/assets/logos/barcelona.svg',
  center: [2.154007, 41.390205],
  zoom: 11,
  featuresInitialZoom: 0,
  unitLength: 'km',
  theme: 'traffico',
  applicationLogo: false,
  loginApplicationLogo: false,
  platesAPI: '',
  showGeographica: true,
  overrideWazeAlerts: true,
  options: {
    sources: ['waze'],
    cartoAccount: 'ambwazeuser',
    baseUrl: 'https://${username}.carto.com',
    mapApiEndpoint: '/api/v1/map?config=${mapConfig}',
    sqlApiEndpoint: '/api/v2/sql?q=${query}',
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.barcelona.ts